import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

/* Snackbar
 * https://notistack.com/api-reference
 */
import { useSnackbar } from 'notistack';

// Components
import AjaxController from '../system/ajaxController';

// Redux slices
import { confimChanges, setContractData, resetObject, setCurrentChangeNr, deleteLastChange } from '../contract/contractSlice';
import { setActivePage, setUser, setToken } from '../../appSlice';

// Semantic UI components
import { Button, Icon, Menu, MenuItem, MenuMenu, Modal, Header, HeaderContent, Segment } from 'semantic-ui-react';

// Styles
import 'semantic-ui-css/semantic.min.css';



const Max2ContractSubmenu = () => {
    // local State
    const [showSave, setShowSave] = useState(false);

    // global state
    const dispatch = useDispatch();
    const contractData    = useSelector((state) => state.contract.data.Contract);
    const contractId      = useSelector((state) => state.app.contractId);
    const dataChanges     = useSelector((state) => state.contract.data.Changes);
    const currentChangeNr = useSelector((state) => state.contract.data.currentChangeNr);
  
    const isDirtyContract = useSelector((state) => state.contract.isDirty);
    const backendUrl      = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);

    const { t } = useTranslation();

    // Snackbar
    const { enqueueSnackbar } = useSnackbar();




    /**
     * Remove lock function
     * 
     * @async 
     */
    const removeLock = async () => {
        // init AJAX controller
        const api = new AjaxController(backendUrl, () => {
            dispatch(setActivePage('START'));
            dispatch(setUser(null));
            dispatch(setToken(null));
        });

        // remove lock
        let response;
        try {
        response = await api.delete('/hotel/'+contractId+'/unlock');
        if (response.status !== 'success') {
            enqueueSnackbar(t('contract.lock.revokeError'), { variant: 'error' });
            return;
        }
        } catch (error) {
            enqueueSnackbar(t('contract.lock.revokeError'), { variant: 'error' });
            return;
        }
    }



    /**
     * @async
     */
    const handleConfimClick = async () => {
        try {
            setShowSave(true);

            // Controller for AJAX requests
            const api = new AjaxController(backendUrl, () => {
                dispatch(setActivePage('START'));
                dispatch(setUser(null));
                dispatch(setToken(null));
            });
    
            // send post request
            const response = await api.put('/contract/' + contractId, contractData);
            setShowSave(false);
            if (response?.status === 'success') {
                enqueueSnackbar(t('contract.submenu.saveSuccess'), { variant: 'success' });
                dispatch(confimChanges())
                removeLock();
            } else {
                enqueueSnackbar(t('contract.submenu.saveError'), { variant: 'error' });
            }
        } catch (err) {
            setShowSave(false);
            enqueueSnackbar(t('contract.submenu.saveError'), { variant: 'error' });
            console.error(err.message);
        }
    }



    /**
     * 
     */
    const handleAbortClick = () => {
        dispatch(resetObject());
        removeLock();
    }



    /**
     * 
     */
    const handleDiscardLastChangeClick = () => {
        dispatch(deleteLastChange())
    }



    /**
     * 
     */
    const handlePrevChangeClick = () => {
        if (currentChangeNr > 1) {
            const prevChangeNr = currentChangeNr - 1;
            const currChange = dataChanges[prevChangeNr-1];
            dispatch(setContractData(currChange))
            dispatch(setCurrentChangeNr(prevChangeNr));
        }
    }


    /**
     * 
     */
    const handleNextChangeClick = () => {
        if (currentChangeNr < dataChanges.length) {
            const nextChangeNr = currentChangeNr + 1;
            const currChange = dataChanges[nextChangeNr - 1];
            dispatch(setContractData(currChange))
            dispatch(setCurrentChangeNr(nextChangeNr));
        }
    }



    if (!isDirtyContract) {
        return <></>
    }

    return (
        <>
        {/* Modal für Speicher-Dialog */}
        <Modal
            closeIcon
            open={showSave}
            onClose={() => setShowSave(false)}
            size='medium'
        >
            <Modal.Content>
                <Segment>
                    <br />
                    <br />
                    <Header as='h2' textAlign='center'>
                    <Icon loading name='spinner' />
                    <HeaderContent>
                        {t('contract.submenu.savingTitle')}
                    </HeaderContent>
                    </Header>
                    <br />
                    <br />
                </Segment>
            </Modal.Content>
        </Modal>
        
        <Menu borderless size='mini' style={{margin: '5px 15px 1px 5px', background: "rgb(51, 51, 51)", borderRadius: '25px', border: '1px solid #999', padding: '5px'}}>
            <MenuItem style={{color: '#eee', fontSize: '10pt', fontWeight: 'bolder'}}>{t('contract.submenu.changesLabel')}</MenuItem>
            <MenuMenu position='right'>
                <MenuItem>
                    {dataChanges.length > 1 && (<Button icon circular onClick={()=>handlePrevChangeClick()}><Icon name='undo' /></Button>)}
                </MenuItem>
                <MenuItem style={{color: '#eee', fontSize: 'small', fontWeight: 'bolder'}}>{currentChangeNr} / {dataChanges.length}</MenuItem>
                <MenuItem>
                    {dataChanges.length > 1 && (<Button icon circular onClick={()=>handleNextChangeClick()}><Icon name='redo' /></Button>)}
                </MenuItem>
            </MenuMenu>
            <MenuMenu position='right'>
                <MenuItem>
                    <Button icon circular labelPosition='left' onClick={()=>handleDiscardLastChangeClick()}>
                        <Icon name='undo' />
                        {t('contract.submenu.discardLast')}
                    </Button>
                </MenuItem>
                <MenuItem>
                    <Button icon circular labelPosition='left' onClick={()=>handleAbortClick()}>
                        <Icon name='undo' />
                        {t('contract.submenu.discardAll')}
                    </Button>
                </MenuItem>
                <MenuItem>
                    <Button icon circular labelPosition='left' primary onClick={()=>handleConfimClick()}>
                        {t('contract.submenu.save')}
                        <Icon name='save' />
                    </Button>
                </MenuItem>
            </MenuMenu>
        </Menu>
        </>
    )
}

export default Max2ContractSubmenu;